/**
 * FilterState → DashboardQuery, the only way a query is built.
 *
 * - selections are pruned to the dimensions the page's bar renders
 *   (docs/design/rules.md §0: a module never filters by a chip it doesn't show)
 * - selection values are sorted, so equal filters make equal cache keys
 */
import type { DashboardQuery, FiltersType, Selections } from '@/data-sources/contract';
import type { FilterState } from '@/store/slices/filtersSlice';

import { dimensionsFor } from './chips';

export function canonicalQuery(
  state: FilterState,
  filtersType: FiltersType | null,
): DashboardQuery {
  const selections: Selections = {};
  for (const dimension of dimensionsFor(filtersType)) {
    const values = state.selections[dimension];
    if (values !== undefined) selections[dimension] = [...values].sort();
  }
  return { range: state.range, compare: state.compare, selections };
}
